export const COLOR_META = {
  rose: { hex: "#C8889F", fr: "Rose poudré", en: "Powder rose", ar: "وردي بودري" },
  ivoire: { hex: "#F0E7DA", fr: "Ivoire", en: "Ivory", ar: "عاجي" },
  noir: { hex: "#2C2420", fr: "Noir", en: "Black", ar: "أسود" },
  sauge: { hex: "#ADB8A5", fr: "Sauge", en: "Sage", ar: "أخضر سيج" },
  camel: { hex: "#C09A6E", fr: "Camel", en: "Camel", ar: "جملي" },
  perle: { hex: "#E8E0D5", fr: "Perle", en: "Pearl", ar: "لؤلؤي" },
};

export const CATEGORY_META = {
  robes: { fr: "Robes", en: "Dresses", ar: "فساتين" },
  hauts: { fr: "Hauts", en: "Tops", ar: "بلوزات وتوبات" },
  jupes: { fr: "Jupes", en: "Skirts", ar: "تنانير" },
  pantalons: { fr: "Pantalons", en: "Trousers", ar: "بناطيل" },
  mailles: { fr: "Mailles", en: "Knitwear", ar: "حياكات" },
  manteaux: { fr: "Manteaux", en: "Coats", ar: "معاطف" },
  accessoires: { fr: "Accessoires", en: "Accessories", ar: "إكسسوارات" },
};

export const COLLECTION_META = {
  essentials: { fr: "Les Essentiels", en: "The Essentials", ar: "الأساسيات" },
  soiree: { fr: "Soirée", en: "Evening", ar: "السهرات" },
  douceur: { fr: "Douceur", en: "Softness", ar: "النعومة" },
  atlas: { fr: "Atlas", en: "Atlas", ar: "أطلس" },
};

export const SIZE_LABELS = {
  Unique: { fr: "Taille unique", en: "One size", ar: "مقاس واحد" },
};

export const SHIPPING = {
  STANDARD_FEE: 40,
  FREE_THRESHOLD: 600,
  EXPRESS_FEE: 90,
};

export const SOCIALS = {
  instagram: "https://instagram.com/mioraboutique_",
  tiktok: "https://tiktok.com/@mioraboutique_",
  snapchat: "https://snapchat.com/add/mioraboutqiue",
};

export const formatPrice = (n) => {
  const v = Number(n);
  const isInt = Math.round(v) === v;
  const s = v.toLocaleString("fr-FR", {
    minimumFractionDigits: isInt ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return `${s} DH`;
};

export const GRADIENTS = [
  "linear-gradient(155deg, #F5EDE4 0%, #E7DACB 55%, #D9C6B4 100%)",
  "linear-gradient(160deg, #F3E7E4 0%, #E3C6CE 60%, #D5AEBB 100%)",
  "linear-gradient(150deg, #EFE9E0 0%, #DCD5C6 50%, #C9BBA6 100%)",
  "linear-gradient(165deg, #F6F0E9 0%, #E9DDD2 60%, #D8C6BC 100%)",
  "linear-gradient(145deg, #EDE4E0 0%, #D9C2C6 55%, #C6A2AC 100%)",
  "linear-gradient(158deg, #F2EDE6 0%, #E0D3C4 45%, #C9B49E 100%)",
];
